import './index.css'

document.addEventListener('DOMContentLoaded', async function () {
  console.info('loaded')
})
